import styled from '@emotion/styled'

export const Tag = styled.div<{ color?: string; hasBorder?: boolean }>(
  ({ color, hasBorder }) => `
  display: flex;
  align-items: center;
  gap: var(--space-1);
  ${
    hasBorder &&
    `
      border: var(--border-width-small) solid ${color ?? 'var(--primitive-solid-neutral-60)'};
      border-radius: var(--border-radius-button-small);
      padding: var(--space-05) var(--space-2);
    `
  }

  .tag-icon::part(icon),
  .tag-text::part(text) {
    color: ${color ?? 'var(--primitive-solid-neutral-60)'};
  }
`
)
